<script lang="ts">
  import Footer from '$components/footer/Footer.svelte';
  import '$src/styles/global.scss';
  import NavBar from '$components/menu/NavBar.svelte';
  import { page } from '$app/stores';
  import Main from '$components/layout/Main.svelte';
  import { goto } from '$app/navigation';
</script>

<Main>
  <NavBar login={() => goto('/')} />
  <section>
    {#if $page.error}
      <h1>{$page.status}: {$page.error.message}</h1>
    {:else}
      <h1>Oh no, something went wrong</h1>
    {/if}
  </section>
  <Footer />
</Main>

<style lang="scss">
  section {
    min-height: 100dvh;
    height: 100dvh;
    display: grid;
    place-content: center;
  }
</style>
